import { SVGProps } from 'react'

export const SwapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.99998 18.75L2.34998 15.1L3.39998 14L5.24998 15.85V8C5.24998 6.96667 5.61664 6.08333 6.34998 5.35C7.08331 4.61667 7.96664 4.25 8.99998 4.25C10.0333 4.25 10.9166 4.61667 11.65 5.35C12.3833 6.08333 12.75 6.96667 12.75 8V15C12.75 15.6333 12.9666 16.1667 13.4 16.6C13.8333 17.0333 14.3666 17.25 15 17.25C15.6333 17.25 16.1666 17.0333 16.6 16.6C17.0333 16.1667 17.25 15.6333 17.25 15V7.15L15.4 9L14.35 7.9L18 4.25L21.65 7.9L20.6 9L18.75 7.15V15C18.75 16.0333 18.3833 16.9167 17.65 17.65C16.9166 18.3833 16.0333 18.75 15 18.75C13.9666 18.75 13.0833 18.3833 12.35 17.65C11.6166 16.9167 11.25 16.0333 11.25 15V8C11.25 7.36667 11.0333 6.83333 10.6 6.4C10.1666 5.96667 9.63331 5.75 8.99998 5.75C8.36664 5.75 7.83331 5.96667 7.39998 6.4C6.96664 6.83333 6.74998 7.36667 6.74998 8V15.85L8.59998 14L9.64998 15.1L5.99998 18.75Z"
      fill="currentColor"
    />
  </svg>
)
